import { Store } from "redux";
import { BehaviorSubject } from "rxjs";
import { MapState, MapStore } from "../types/store-schema";

type StoreConverterReturnType = { store: MapStore; complete: () => void };

export function convertReduxStoreReadToRXJS<RootStoreType>(reduxStore: Store, accessor: (state: RootStoreType) => MapState): StoreConverterReturnType {
    const initialState = accessor(reduxStore.getState());
    const storeSubject = new BehaviorSubject(initialState);

    const unsubscription = reduxStore.subscribe(() => {
        storeSubject.next(accessor(reduxStore.getState()));
    });

    const convertedStore: MapStore = {
        change: storeSubject,
    };

    return {
        store: convertedStore,
        complete: () => {
            unsubscription();
            storeSubject.complete();
        },
    };
}
